<ion-select-option *ngIf="noSelectionDisplayText || noSelectionValue" [value]="noSelectionValue">{{ noSelectionDisplayText }}</ion-select-option>
<ion-select-option *ngFor="let item of listItems" [value]="listItemValueProperty ? item[listItemValueProperty] : item">
    {{ listItemDisplayTextProperty ? item[listItemDisplayTextProperty] : item }}
</ion-select-option>